"use client"
import React, { useEffect } from "react"
import { ThemeProvider as NextThemesProvider } from "next-themes"

export function ThemeProvider({
  children,
  initialTheme,
}: {
  children: React.ReactNode
  initialTheme?: "light" | "dark" | "system" | string
}) {
  useEffect(() => {
    console.debug("ThemeProvider mounted", { initialTheme })
  }, [initialTheme])

  return (
    <NextThemesProvider attribute="class" defaultTheme={initialTheme ?? "system"} enableSystem>
      {children}
    </NextThemesProvider>
  )
}
